import React, {useEffect} from "react";
import {Button, Form, Input,Select,Row,Col} from "antd";
import {useModel} from "../../../models";

export default function () {

    const [searchForm] = Form.useForm();
    const [{searchParam,selectedTypeNode}, {setSearchParam, loadMaterialList}] = useModel("material");
    const [{engineTypeDict}] = useModel("cmDict");    
    useEffect(() => {
        searchForm.setFieldsValue(searchParam);
    }, []);

    const onFinish = () => {
        console.log()
        const params = searchForm.getFieldValue();

        if (selectedTypeNode) {
            params.category  = selectedTypeNode.key;
            
        }else{
            params.category  = null;
        }
        params.pageSize=15;
        params.pageNum=1;
        setSearchParam(params)
        loadMaterialList({data:params});
    }

    const onReset = () => {
        searchForm.resetFields();
        setSearchParam({})
        loadMaterialList({data:{}});


    }

    return (
        <Form
            form={searchForm}
            name="material_search"
            layout="inline"
            onFinish={onFinish}
            onValuesChange={e => setSearchParam(e)}
        >
            {/* <Row gutter={24}>
                <Col span={6}></Col>
            </Row> */}
            <Form.Item
                name="materialCode"
                label="商品编号"
            >
                <Input placeholder="商品编码"/>
            </Form.Item>
            <Form.Item
                name="materialName"
                label="商品名称"
            >
                <Input placeholder="商品名称"/>
            </Form.Item>
            <Form.Item
                name="replaceNum"
                label="图号"
            >
                <Input placeholder="图号"/>
            </Form.Item>
            <Form.Item
                name="engineType"
                label="发动机型号"
            >
                <Select
                showSearch
                allowClear={true}
                style={{width:"200px"}}
                placeholder="发动机型号"
                filterOption={(input, option) => option.label.indexOf(input) >= 0}
                options={engineTypeDict}
            />
            </Form.Item>
            <Form.Item shouldUpdate={true}>
                {() => (
                    <>
                        <Button
                            type="primary"
                            htmlType="submit"
                        >
                            查询
                        </Button>
                        <Button
                            htmlType="submit"
                            className="margin-left-8"
                            onClick={onReset}
                        >
                            重置
                        </Button>
                    </>
                )}
            </Form.Item>
        </Form>
    );

};